<template>
  <div>
    <div class="d-flex justify-content-center" v-if="parentIsLoading">
      <CSpinner color="info" />
    </div>
    <div v-else>
      <div class="overflow-hidden">
        <CRow>
          <CCol>
            <div class="ui-type-caption text-uppercase text-gray-600">
              {{ $t("role.orders.rounds.orders.details.title") }}
            </div>
            <div class="ui-type-display-sm">
              {{ orderId(order) }} - {{ orderFamilyName(order) }}
            </div>
            <div class="ui-type-body mb-2">
              <OrdersContacts
                :title="$t('role.orders.contacts.title')"
                :contacts="orderDeliveryIslandContacts(order)"
              />
            </div>
          </CCol>
        </CRow>

        <CRow class="justify-content-between mb-3">
          <CCol col="auto">
            <font-awesome-icon icon="warehouse" />
            {{ $t("role.orders.rounds.orders.details.prepareFrom") }}
            <strong>
              {{ orderDeliveryDate(order, "dd-MM") }}
              {{ $t("role.orders.rounds.orders.details.to") }}
              {{ orderDeliveryDate(order, "HH:mm") }}</strong
            >
          </CCol>
          <CCol col="auto">
            <CButton
              color="primary"
              @click.prevent="allReady"
              :disabled="!canView(PERMS.ORDERS_EDIT)"
              >{{
                $t("role.orders.rounds.orders.details.allDeliveredBtn")
              }}</CButton
            >
          </CCol>
        </CRow>
      </div>

      <CCard class="mb-2">
        <CCardBody>
          <ProductsTable :order="order" />
        </CCardBody>
      </CCard>
    </div>
  </div>
</template>

<script>
import orderManagementMixin from "../../../../../../mixins/orderManagement";
import ProductsTable from "./ProductsTable";
import OrdersContacts from "../../../share/OrdersContacts";
import EventBus from "../../../../../../helpers/EventBus";
import { filtersMap } from "../../filtersMap";
import { PERMS } from "../../../../../../helpers/acl";

export default {
  name: "Detail",

  components: {
    ProductsTable,
    OrdersContacts,
  },

  mixins: [orderManagementMixin],

  props: {
    order: { type: Object, required: true },
    parentIsLoading: { type: Boolean, default: false },
  },

  data() {
    return {
      PERMS,
      view: "products",
    };
  },

  mounted() {},

  methods: {
    allReady() {
      const orders = [this.order.order.id];
      const onSuccess = (response) => {
        EventBus.$emit("orders:refresh");
      };
      this.$store
        .dispatch("rounds/updateStatusBatch", {
          status: filtersMap("orders.statusCode.next"),
          orders,
        })
        .then(onSuccess);
    },

    canView(perm) {
      return this.$store.getters["connections/havePermission"](perm);
    },
  },
};
</script>
